var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentReady)?_c('section',{staticClass:"container-wrapper model-page"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('VinChecker'),_c('div',{staticClass:"model-page__models"},[_c('Cars',{attrs:{"cars":_vm.models},on:{"select":_vm.onModelSelected}})],1),_c('div',{staticClass:"model-page__no"})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }